import { getSfcoreAccessKeyDomains, getSfcoreUrl } from '@/helpers/envHelper';

const getAMProductDetails = async ({
  productCode,
  productInstanceId,
}) => {
  try {
    const sfcoreUrl = getSfcoreUrl();
    const apiAccessKey = getSfcoreAccessKeyDomains();

    if (!sfcoreUrl || !apiAccessKey || !productInstanceId) {
      return null;
    }

    const requestBody = {
      productInstanceId,
      requestInfo: {
        apiAccessKey,
        clientId: 'AccountManager',
        method: 'getAMProductDetails',
        service: 'ProductAPI',
      },
    };

    if (productCode) {
      requestBody.productCode = productCode;
    }

    const response = await fetch(sfcoreUrl+'?method=getAMProductDetails', {
      body: JSON.stringify({ request: requestBody }),
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
    });

    let json;

    try {
      json = await response.json();
    } catch {
      console.error('Error parsing product details response:', response);
      return null;
    }

    return json?.response?.data ?? null;
  } catch (error) {
    console.error(error);
    return null;
  }
};

export default getAMProductDetails;
